/* eslint-disable camelcase, capitalized-comments, curly */
import PropTypes from "prop-types";
import { useMemo } from "react";

import { useReport } from "../ReportContext";
import { useUser } from "../../UserContext"

const rangeNames = ["limited", "underutilized", "optimal", "elevated", "excessive"]
const ranges = {
	dependent: [
		// limited
		11,
		// underutilized
		15,
		// optimal
		20,
		// elevated
		25,
		// excessive
	],
	disconnected: [
		// limited
		4.5,
		// underutilized
		7,
		// optimal
		11,
		// elevated
		16.5,
		// excessive
	],
	independent: [
		// limited
		11,
		// underutilized
		15,
		// optimal
		20,
		// elevated
		28,
		// excessive
	],
	interdependent: [
		// limited
		40,
		// underutilized
		50,
		// optimal
		60,
		// elevated
		64.5
		// excessive
	],
};
const strategyField = {
	dependent: "lSHO_dist",
	disconnected: "lSLO_dist",
	independent: "hSLO_dist",
	interdependent: "hSO_dist",
};

const determineRange = (percentile, strat) => {
	const strategy = strat.toLowerCase();
	if (percentile < ranges[strategy][0]) return rangeNames[0];
	if (percentile < ranges[strategy][1]) return rangeNames[1];
	if (percentile < ranges[strategy][2]) return rangeNames[2];
	if (percentile < ranges[strategy][3]) return rangeNames[3];
	return rangeNames[4];
};

const RelationshipStrategyAssessment = ({ strategy }) => {
	const { respondent } = useUser();
	const { reportContent: { acf: { relationship_strategies } } } = useReport();

	const grade = useMemo(() => {
		if (!respondent) {
			return "unknown";
		}
		const percentile = respondent?.weqProfile?.stats?.[strategyField[strategy]];
		const range = determineRange(percentile, strategy);
		return range;
	}, [respondent?.weqProfile?.percentiles?.[strategyField[strategy]], strategy]);

	return <div className={`assessment-text rating-${grade}`} dangerouslySetInnerHTML={{ __html: relationship_strategies[strategy.toLowerCase()][grade] }} />
}

RelationshipStrategyAssessment.propTypes = {
	strategy: PropTypes.oneOf(["dependent", "disconnected", "independent", "interdependent"]).isRequired
};

export default RelationshipStrategyAssessment;